// extracted by mini-css-extract-plugin
module.exports = {"container":"container--32vEw","respondent":"respondent--2rPnv","order":"order--18wil","cards":"cards--3Zlpg","line":"line--3u24m","label":"label--1LYke","text":"text--3Uwxi"};